'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'
import { useSortBy } from 'react-instantsearch'

import { IconCheck } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useProductSearchContext } from '../../context/productSearchContextValue'

export const ProductSearchRefinementSortingChipButtonList: FC = () => {
  const { productSearchConfig } = useProductSearchContext()

  const { currentRefinement, options, refine } = useSortBy({
    items: productSearchConfig.sortByIndexes,
  })

  return (
    <div className="flex shrink-0 items-start gap-2 overflow-x-auto bg-light-primary-medium p-4">
      {options.map((option) => (
        <Button
          className={clsx(
            currentRefinement === option.value
              ? 'bg-light-brand-high shadow-m'
              : 'bg-light-brand-medium',
          )}
          data-qa-id={`sort-by-${option.label}`}
          key={option.value}
          name={`sort-by-${option.label}`}
          onClick={() => {
            refine(option.value)
          }}
          size="large"
          variant="filled"
        >
          <span className="flex flex-row items-center justify-center text-m font-medium text-dark-primary-max">
            {currentRefinement === option.value && (
              <IconCheck className="size-7" />
            )}
            {option.label}
          </span>
        </Button>
      ))}
    </div>
  )
}
